export interface KeyValueI {
  id?: number;
  key: string;
  value: string;
  optionalValue?: any;
}

export class KeyValue implements KeyValueI {
  public id?: number;
  public key: string;
  public value: string;
  public optionalValue?: any;

  constructor(keyText: string, valueText: string, optionalValue?: any, id?: number) {
    this.id = id;
    this.key = keyText || '';
    this.value = valueText || '';
    this.optionalValue = optionalValue;
  }
}

export interface Filters {
  id?: number;
  name: string; // ie: "Colors"
  hint: string; // ie: "Dark Red"
  value?: string; // ie: "Red"
  radioValues?: Array<String>;
  dropDown?: Array<String>;
  type?: string;
  disabled?: boolean;
  multiple?: boolean;
}
export interface AdvancedSearchFormData {
  title: string; // ie "Filters"
  description: string; // ie: ""
  filters: Array<Filters>;
}

export class AdvancedSearchContainerData {
  advancedSearchContainer: any = {};

  titleAdvancedSearch: string = ''; // ie: "Advanced Search"
  excerptAdvancedSearch: string = ''; // ie: "Use this tool to filter your data."
}

export interface ActionI {
  key: string;
  value: string;
  disabled: boolean;
  icon: string;
}

export class Action implements ActionI {
  public key: string;
  public value: string;
  public disabled: boolean;
  public icon: string;

  constructor(res: any){
    this.key = res?.key;
    this.value = res?.value;
    this.disabled = res?.disabled;
    this.icon = res?.icon;
  }
}
